// src/components/UI/AlertPills.jsx
import React, { memo, useEffect, useRef, useState } from "react";
import UIIcon from "../Common/UIIcon";

function normalizePillType(type) {
   const key = String(type || "")
      .trim()
      .toLowerCase();

   if (key === "warning" || key === "warn") return "warning";
   if (
      key === "error" ||
      key === "err" ||
      key === "alert" ||
      key === "danger"
   ) {
      return "error";
   }
   if (key === "success" || key === "ok") return "success";
   return "info";
}

function AlertPills({ messages = [], onDismiss = () => {} }) {
   // Hooks trebuie chemate indiferent de mesaje
   const [leaving, setLeaving] = useState(false);
   const pillRef = useRef(null);

   const hasMessage = Array.isArray(messages) && messages.length > 0;
   const m = hasMessage ? messages[messages.length - 1] : null;
   const normalizedType = normalizePillType(m?.type);

   // când se schimbă mesajul, resetăm starea de ieșire
   useEffect(() => {
      if (!hasMessage) return;
      setLeaving(false);
   }, [hasMessage, m?.id, m?.text, m?.type]);

   const handleDismiss = () => {
      if (hasMessage && !leaving) setLeaving(true);
   };

   const handleCloseClick = (e) => {
      e.stopPropagation();
      handleDismiss();
   };

   const handleTransitionEnd = (e) => {
      if (!hasMessage) return;
      if (e.target === pillRef.current && leaving) {
         onDismiss(); // abia după animație îl scoatem din state
      }
   };

   // abia acum putem ieși dacă nu e mesaj
   if (!hasMessage) return null;

   return (
      <div className="pillstack" role="region" aria-label="Mesaje sistem">
         <div
            ref={pillRef}
            className={`pill pill--${normalizedType} ${
               leaving ? "pill--leaving" : ""
            }`}
            role={normalizedType === "error" ? "alert" : "status"}
            aria-live={normalizedType === "error" ? "assertive" : "polite"}
            onClick={handleDismiss}
            onTransitionEnd={handleTransitionEnd}
            tabIndex={0}
            title="Clic pentru a închide"
            onKeyDown={(e) => {
               if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  handleDismiss();
               }
            }}
         >
            <span className="pill__text">{m.text}</span>
            <button
               type="button"
               className="pill__close"
               aria-label="Închide mesajul"
               title="Închide"
               onClick={handleCloseClick}
            >
               <UIIcon name="close" className="pill__close-icon" />
            </button>
         </div>
      </div>
   );
}

export default memo(AlertPills);
